import React, {useEffect} from "react";
import styled from "styled-components";
import {FileUploadButton} from "./features/FileUploadButton";
import {FileList} from "./features/FileList";

interface UploadedFile extends File {
    fileOrgname?: string;
}

type FileItem = {
    accountId?: string;
    fileId?: number;
    fileKey?: string;
    fileOrgname?: string;
    fileType?: string;
    fileUrl?: string;
};

type FileProps = {
    onFilesChange: (files: File[]) => void;
    uploadedFiles?: UploadedFile[] | File[];
    title?: string;
    mode?: string;
    downloadMutate?: (params: {
        data: any;
        type?: string;
        isDonwloadBtn?: boolean;
    }) => void;
    fileRef: React.RefObject<HTMLInputElement | null>;
    files: (UploadedFile & FileItem)[];
    handleChange: () => void;
    handleButtonClick: () => void;
    deleteFile: (file: UploadedFile) => void;
    deleteUpdatedFile: (file: UploadedFile) => void;
};

const FileUploadWithText: React.FC<FileProps> = ({
                                                     onFilesChange,
                                                     uploadedFiles = [],
                                                     title = "파일 업로드",
                                                     mode = "R",
                                                     downloadMutate,
                                                     files,
                                                     fileRef,
                                                     handleChange,
                                                     handleButtonClick,
                                                     deleteFile,
                                                     deleteUpdatedFile,
                                                 }) => {
    useEffect(() => {
        onFilesChange(files);
    }, [files, onFilesChange]);

    return (
        <S.Container>
            {mode !== "R" && (
                <FileUploadButton
                    fileRef={fileRef}
                    handleChange={handleChange}
                    handleButtonClick={handleButtonClick}
                    title={title}
                />
            )}
            <FileList
                files={files}
                deleteFile={deleteFile}
                deleteUpdatedFile={deleteUpdatedFile}
                mode={mode}
                downloadMutate={downloadMutate}
            />
        </S.Container>
    );
};

export default FileUploadWithText;

const S = {
    Container: styled.div`
        display: flex;
        align-items: center;
        gap: 4px;

        input[type="file"] {
            display: none;
        }
    `,
};
